import { NOTIFICATIONS_MUTATIONS } from "./mutations-enum";
import { NotificationStorage } from "@/helpers/NotificationStorage";

export default {
    [NOTIFICATIONS_MUTATIONS.SET_NOTIFICATIONS](state, notifications) {
        state.notifications = notifications;
    },
    [NOTIFICATIONS_MUTATIONS.ADD_NOTIFICATION](state, notification) {
        // Evita duplicati se la notifica ha un ID ed è già presente
        if (notification.id && state.notifications.some(n => n.id === notification.id)) {
            return;
        }

        const newNotif = {
            ...notification,
            id: notification.id || (Date.now() + Math.random().toString(36).substr(2, 9)),
            read: notification.read !== undefined ? notification.read : false,
            timestamp: notification.timestamp || new Date().toISOString()
        };
        state.notifications.unshift(newNotif);
        
        // Persistenza opzionale qui o nell'action
        NotificationStorage.save(newNotif);

        // Limita a 50 notifiche
        if (state.notifications.length > 50) {
            state.notifications = state.notifications.slice(0, 50);
        }
    },
    [NOTIFICATIONS_MUTATIONS.MARK_ALL_AS_READ](state) {
        state.notifications.forEach(notification => {
            notification.read = true;
            NotificationStorage.markAsRead(notification.id);
        });
    },
    [NOTIFICATIONS_MUTATIONS.MARK_SINGLE_AS_READ](state, notificationId) {
        const notification = state.notifications.find(n => n.id === notificationId);
        if (notification) {
            notification.read = true;
            NotificationStorage.markAsRead(notificationId);
        }
    },
    [NOTIFICATIONS_MUTATIONS.REMOVE_NOTIFICATIONS_BY_TYPE](state, type) {
        state.notifications = state.notifications.filter(n => {
            const notifType = String(n.data?.type || n.type || null);
            return notifType !== String(type);
        });
    }
};